import { Review } from "@components"
import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
export const ReviewList = () => {
  const ReviewData = useStaticQuery(graphql`
    query {
      allSanityClientReviews {
        edges {
          node {
            slug {
              current
            }
            clientName
            designation
            companyName
            clientImage {
              asset {
                url
              }
            }
            clientVideo {
              asset {
                url
              }
            }
            publishDate
            review
          }
        }
      }
    }
  `)
  const reviews: any = ReviewData?.allSanityClientReviews?.edges.map(
    (node: any) => node?.node
  )
  const [visibleReviews, setVisibleReviews] = React.useState(3)

  const handleViewMore = () => {
    if (visibleReviews >= reviews.length) {
      setVisibleReviews(3) // Reset to initial state
    } else {
      setVisibleReviews(visibleReviews + 3)
    }
  }
  return (
    <div className="bg-completedProject lg:w-full w-11/12 container mx-auto rounded-lg py-10 mt-14 mb-10">
      {reviews?.slice(0, visibleReviews).map((review: any, index: number) => (
        <>
          <Review
            key={index}
            title={review?.companyName}
            profileTitle={review?.clientName}
            profileDescription={review?.designation}
            description={review?.review}
            stars={5}
            isReverse
            isReview
            isCentered
            clientRoundedImg={review?.clientImage}
            clientVideo={review?.clientVideo}
          />
          <div className="bg-[#9F69FF] container mx-auto h-[1px] w-[90%] mt-10"></div>
        </>
      ))}
      {/* <div className="bg-[#9F69FF] container mx-auto h-[1px] w-[90%] mt-10"></div>
      <Review
        title="KINGDOM DOMAIN COLLEGE"
        profileTitle="Danielle Jenkins"
        profileDescription="Super Model"
        description="“ Trust Haseeb and his team with our branding and website - they did not disappoint.”"
        stars={5}
        isReview
        isCentered
      />
      <div className="bg-[#9F69FF] container mx-auto h-[1px] w-[90%] mt-10"></div>
      <Review
        title="KINGDOM DOMAIN COLLEGE"
        profileTitle="Danielle Jenkins"
        profileDescription="Super Model"
        description="“ Trust Haseeb and his team with our branding and website - they did not disappoint.”"
        stars={5}
        isReview
        isCentered
      /> */}
      {reviews.length > 3 && ( // Conditionally render the button
        <div className="flex justify-center mt-10">
          <button
            onClick={handleViewMore}
            className="border border-[#9F69FF] py-2 font-semibold text-purple rounded-lg w-[80%]"
          >
            {visibleReviews >= reviews.length
              ? "View Less"
              : "View More Reviews"}
          </button>
        </div>
      )}
    </div>
  )
}
